import { useQuery } from '@tanstack/react-query'
import { supabase } from '../api'

const getAssets = async () => {
  const { data, error } = await supabase
    .from('assets')
    .select('*')
    .eq('active', true);

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useAssets() {
  return useQuery({
    queryKey: ['assets'],
    queryFn: () => getAssets(),
    staleTime: 60000,
  })
}
